import { Image } from 'antd'
import { useSelector } from 'react-redux'
import ProfileMenu from './ProfileMenu'
import LanguageSelector from './LanguageSelector'
import Theme from './theme'

import Logo from '../../../assets/logo.png'
import LogoMobile from '../../../assets/logo-mobile.png'
import Company from './Company'
import Wallet from './Wallet'
import Status from './Status'

const TopBar = () => {
  const isMobileView = useSelector(s => s._settings.isMobileView)
  const isUserAuthorized = useSelector(s => s._auth.authorized)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
      }}
    >
      <div style={{ width: '256px' }}>
        <Image src={isMobileView ? LogoMobile : Logo} preview={false} width={!isMobileView ? 180 : undefined} height={isMobileView ? 55 : undefined} />
      </div>

      <div style={{ display: 'inline-flex', marginRight: '20px' }}>
        <Company />
      </div>
      <div style={{ display: 'inline-flex', marginRight: '20px' }}>
        <Wallet />
      </div>
      <div style={{ display: 'inline-flex', marginRight: 'auto' }}>
        <Status />
      </div>

      <div style={{ display: 'inline-flex', marginLeft: 'auto' }}>
        <Theme />
        <LanguageSelector />
        {isUserAuthorized && <ProfileMenu />}
      </div>
    </div>
  )
}

export default TopBar
